import moment from 'moment';

export function formatDate(date) {
  const yyyy = date.getFullYear();
  let mm = date.getMonth() + 1; // Months start at 0!
  let dd = date.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  return yyyy + '-' + mm + '-' + dd;
}

export function formatDateTime(timestamp) {
  return moment(moment.utc(timestamp).toLocaleString()).format('YYYY MMM DD hh:mm A');
}
